import type { Chain } from "@suse-o11y/chain";
import type { Defaultable } from "@suse-o11y/defaultable";
import type { Functor } from "@suse-o11y/functor";
import { Matchable } from "@suse-o11y/matchable";

class Denied extends Matchable<"denied"> implements Functor<never>, Chain<never>, Defaultable<never> {
	protected readonly __name = "denied" as const;

	public isGranted(): false {
		return false;
	}

	public isDenied(): this is Denied {
		return true;
	}

	public getOrElse<TFallback>(fallback: TFallback): TFallback {
		return fallback;
	}

	public transform(): this {
		return this;
	}

	public chain(): this {
		return this;
	}
}

export { Denied };
